import router from './router'
import { isMobile } from './utils/isMobile.js'
import { mobileRoutes } from './router/m/index'
import { pcRoutes } from './router/pc/index'

// 判断当前设备的型号从而改变当前路由
if (isMobile()) {
  router.addRoute(mobileRoutes[0])
} else {
  pcRoutes.forEach((v) => {
    router.addRoute(v)
  })
}
// router.addRoute(isMobile() ? mobileRoutes[0] : ...pcRoutes)
